import type { ReactNode } from "react";
import styles from "./empty-state.module.css";

export interface EmptyStateProps {
  /** Font Awesome icon class, e.g. "fa-regular fa-folder-open". Defaults to inbox icon. */
  icon?: string;
  /** Short heading shown below the icon. */
  title?: string;
  /** Supporting description below the title. */
  text?: string;
  /** Optional action element rendered under the text (button, link, etc). */
  action?: ReactNode;
  /** Compact variant — smaller padding/icon for use inside cards or sidebars. */
  compact?: boolean;
  /** Extra class on the outer wrapper. */
  className?: string;
}

export default function EmptyState({
  icon = "fa-regular fa-folder-open",
  title = "Nothing to show yet",
  text,
  action,
  compact = false,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={[
        styles.wrapper,
        compact ? styles.wrapperCompact : "",
        className || "",
      ]
        .filter(Boolean)
        .join(" ")}
      role="status"
      aria-live="polite"
    >
      <div
        className={`${styles.iconCircle} ${compact ? styles.iconCircleCompact : ""}`}
        aria-hidden="true"
      >
        <i className={`${icon} ${styles.icon} ${compact ? styles.iconCompact : ""}`}></i>
      </div>
      <h3 className={`${styles.title} ${compact ? styles.titleCompact : ""}`}>
        {title}
      </h3>
      {text && (
        <p className={`${styles.text} ${compact ? styles.textCompact : ""}`}>
          {text}
        </p>
      )}
      {action && <div className={styles.action}>{action}</div>}
    </div>
  );
}
